/**
 * Enum for settings type.
 * @readonly
 * @enum {{key: string, value: string}}
 */
const settingsTypeEnum = Object.freeze({
  MSKUFORMULA: { key: 'MSKUFORMULA', value: 'MSKUFORMULA' },
  PALLETCONTACT: { key: 'PALLETCONTACT', value: 'PALLETCONTACT' },
  THEMESETTINGS: { key: 'THEMESETTINGS', value: 'THEMESETTINGS' },
  NOTIFICATION_PREFERENCES: { key: 'NOTIFICATION_PREFERENCES', value: 'NOTIFICATION_PREFERENCES' },
  INBOUND_SHIPMENT_ITEMS_GRID: { key: 'INBOUND_SHIPMENT_ITEMS_GRID', value: 'INBOUND_SHIPMENT_ITEMS_GRID' },
  DATAGRID_STATES: { key: 'DATAGRID_STATES', value: 'DATAGRID_STATES' },
  STORE_FBM_COUNTRY: { key: 'STORE_FBM_COUNTRY', value: 'STORE_FBM_COUNTRY' },
  AUTO_PRICING: { key: 'AUTO_PRICING', value: 'AUTO_PRICING' },
  STORE_PULL_AMZ_RETURN_ORDER: { key: 'STORE_PULL_AMZ_RETURN_ORDER', value: 'STORE_PULL_AMZ_RETURN_ORDER' },
  STORE_PULL_AMZ_REMOVAL_ORDER: { key: 'STORE_PULL_AMZ_REMOVAL_ORDER', value: 'STORE_PULL_AMZ_REMOVAL_ORDER' },
  FREESTORAGEDAYCOUNT: {
    key: 'FREE_STORAGE_DAY_COUNT',
    value: 'FREE_STORAGE_DAY_COUNT',
    text: 'Free Storage Day Count',
  },
  STORAGE_FEE_INVENTORY_TYPES: {
    key: 'STORAGE_FEE_INVENTORY_TYPES',
    value: 'STORAGE_FEE_INVENTORY_TYPES',
    text: 'Storage Fee Inventory Types',
  },
  DAILYSTORAGEFEEPERQF: {
    key: 'DAILY_STORAGE_FEE_PER_QF',
    value: 'DAILY_STORAGE_FEE_PER_QF',
    text: 'Daily Storage Fee Per Cubic Feet',
  },
})

export default settingsTypeEnum
